import { render, staticRenderFns } from "./stepFour.vue?vue&type=template&id=ebc2e13a&"
import script from "./stepFour.vue?vue&type=script&lang=js&"
export * from "./stepFour.vue?vue&type=script&lang=js&"
import style0 from "./stepFour.vue?vue&type=style&index=0&id=ebc2e13a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports